import { FlagUrlPipe } from 'src/app/pipes/flag-url/flag-url.pipe';
import { Component, OnInit } from '@angular/core';
import { IonButton } from '@ionic/angular/standalone';

@Component({
    selector: 'app-template-coming-soon',
    templateUrl: './template-coming-soon.component.html',
    styleUrls: ['./template-coming-soon.component.scss'],
    imports: [FlagUrlPipe, IonButton]
})
export class TemplateComingSoonComponent  implements OnInit {

  modal?: HTMLIonModalElement;

  constructor() { }

  ngOnInit() {}

}
